/* eslint-disable @typescript-eslint/no-wrapper-object-types */
import EqualsUtility from '../../utilties/EqualsUtility.js';
// eslint-disable-next-line jsdoc/require-jsdoc
export default function KompisElementPropertyDecorator(descriptor) {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    return function (target, propertyName) {
        const constructor = target.constructor;
        // For some reason the constructor is pointing to the same object
        // Therefore we create new objects
        if (constructor.propertyConstructor !== constructor) {
            constructor.propertyConstructor = constructor;
            constructor.propertyAttributeMap = new Map();
            constructor.propertyDeclarations = new Map();
            constructor.requiredProperties = [];
        }
        const attributeName = propertyName.toLowerCase();
        if (!constructor.propertyAttributeMap.get(attributeName)) {
            constructor.propertyAttributeMap.set(attributeName, propertyName);
        }
        if (!constructor.propertyDeclarations.get(propertyName)) {
            constructor.propertyDeclarations.set(propertyName, {
                type: descriptor.type || String,
                required: descriptor.required || false,
                synchronous: descriptor.synchronous || false,
                defaultValue: descriptor.required ? null : undefined
            });
            if (descriptor.required) {
                constructor.requiredProperties.push(propertyName);
            }
        }
        Object.defineProperty(target, propertyName, {
            get: function () {
                const value = this.properties.get(propertyName);
                return value !== undefined ? value : null;
            },
            set: function (value) {
                if (this.isRendering) {
                    throw new Error('Failed to set property as the component is rendering. Do not change properties internally.');
                }
                // We assume that propertyDeclaration is NOT undefined here.
                const propertyDeclaration = (this.constructor.propertyDeclarations.get(propertyName));
                if (!this.properties) {
                    // HAPPY-DOM BUG: Setter called on shadowed property initialisation. (i.e: "prefix"): https://github.com/capricorn86/happy-dom/issues/654
                    return;
                }
                const previousValue = this.properties.get(propertyName) !== undefined
                    ? this.properties.get(propertyName)
                    : null;
                const isDefaultValue = propertyDeclaration.defaultValue === undefined;
                if (propertyDeclaration.defaultValue === undefined) {
                    propertyDeclaration.defaultValue = value !== undefined ? value : null;
                }
                const newValue = value === null || value === undefined
                    ? propertyDeclaration.defaultValue !== null
                        ? propertyDeclaration.defaultValue
                        : null
                    : value;
                this.properties.set(propertyName, newValue);
                if (!isDefaultValue && !EqualsUtility.deepEquals(newValue, previousValue)) {
                    if (this.changedProperties.get(propertyName) === undefined) {
                        this.changedProperties.set(propertyName, previousValue);
                    }
                    if (propertyDeclaration.synchronous) {
                        this.update();
                    }
                    else {
                        this.requestUpdate();
                    }
                }
            }
        });
    };
}
//# sourceMappingURL=KompisElementPropertyDecorator.js.map